import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import AddTimeLog from './sections/addtimelog.jsx';
import AddBasicTimeLog from './sections/addBasicTimelog.jsx';


const AssignedProjects = () => {
    const [getDepartment, setDepartment] = useState(null);
    const [basicProjects, setBasicProjects] = useState([]);
    const [projects, setProjects] = useState([]);
    const [projectId, setProjectId] = useState(null);
    const [projectName, setProjectName] = useState(null);

    const fetchBasicProjects = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/basic_project`)
            .then(response => {
                setBasicProjects(response.data.projects);
                setDepartment(response.data.department);                
            })
            .catch(error => {
                console.error("Error fetching projects!", error);
                setDepartment(null);
                setBasicProjects([]);
            });
    };

    const fetchProjects = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/assigned_projects`)
            .then(response => {
                setProjects(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching projects!", error);
                setProjects([]);
            });
    };

    useEffect(() => {
        fetchBasicProjects();
        fetchProjects();
    }, []);
    

    const handleBasicProjectChange = async({pId, pName}) => {
        setProjectId(pId);
        setProjectName(pName);
    }

    const filteredBasicProjects = () => {
        if (!getDepartment) return [];
    
        let typesToInclude;
        if (getDepartment ) {
            typesToInclude = [`${getDepartment}`, '0'];
        }else {
            typesToInclude = ['0'];
        }
    
        return basicProjects.filter(project => typesToInclude.includes(project.type));
    };
    
    return(
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Assigned Projects</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Assigned Projects</li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Channel</th>
                                                <th>Client</th>
                                                <th>Project</th>
                                                <th>Status</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {projects.length > 0 && (
                                                projects.map((project) => (
                                                    <tr key={project.id}>
                                                        <td>{project.channel}</td>
                                                        <td>{project.client}</td>
                                                        <td>{project.project}</td>
                                                        <td>
                                                            <Link className="btn btn-white btn-sm btn-rounded mr-2 dropdown-toggle" to="#" aria-expanded="false">
                                                                {project.status === '1' &&
                                                                    <><i className="fa-regular fa-circle-dot text-success"></i> Active</>
                                                                }
                                                                {project.status === '3' &&
                                                                    <><i className="fa-regular fa-circle-dot text-purple"></i> On Hold</>
                                                                }
                                                                {project.status === '2' &&
                                                                    <><i className="fa-regular fa-circle-dot text-info"></i> Completed</>
                                                                }
                                                                {project.status === '4' &&
                                                                    <><i className="fa-regular fa-circle-dot text-danger"></i> Inactive</>
                                                                }
                                                            </Link>
                                                        </td>
                                                        <td className="text-end">
                                                            {project.status === '1' &&
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => setProjectId(`${project.id}`)}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#add_timelog_${project.id}`}>
                                                                                <i className="fa-solid fa-pencil m-r-5"></i> Add Time</Link>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                            {
                                                filteredBasicProjects().length > 0 && (
                                                    filteredBasicProjects().map((project) => (
                                                        <tr key={project.id}>
                                                            <td>Visions</td>
                                                            <td>Visions</td>
                                                            <td>{project.name}</td>
                                                            <td>
                                                                <Link className="btn btn-white btn-sm btn-rounded mr-2 dropdown-toggle" to="#" aria-expanded="false">
                                                                    <i className="fa-regular fa-circle-dot text-success"></i> Active
                                                                </Link>
                                                            </td>
                                                            <td className="text-end">                                                                
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => handleBasicProjectChange({ pId: project.id, pName: project.name })}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#add_basic_timelog_${project.id}`}>
                                                                                <i className="fa-solid fa-pencil m-r-5"></i> Add Time</Link>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AddTimeLog list={fetchProjects} projectId={projectId} />
            <AddBasicTimeLog list={fetchProjects} projectId={projectId} projectName={projectName}/>
        </>
    );
}

export default AssignedProjects